import * as React from "react";
import { useNavigate } from "react-router-dom";
import {
  IconChecks,
  IconCircleMinus,
  IconCopy,
  IconEdit,
  IconHome,
  IconTrash,
} from "@tabler/icons-react";
import dayjs from "dayjs";

import {
  Title,
  Text,
  Grid,
  Paper,
  Tooltip,
  Modal,
  ActionIcon,
  Divider,
  useMantineTheme,
  Flex,
  Stack,
  Badge,
} from "@mantine/core";
import { useSearchParams } from "react-router-dom";
import { useQueryClient } from "@tanstack/react-query";

import { useUseCaseBasic, useUseCaseMatchDetails } from "../../../hooks";
import DatasetData from "../Data/DatasetData";
import Loading from "src/ui/Loading";

function Details({
  status,
  statusId,
}: {
  status: string | null | undefined;
  statusId: string | null | undefined;
}) {
  const theme = useMantineTheme();

  return (
    <Grid gutter={"xs"} columns={12}>
      <Grid.Col span={12}>
        <Flex gap="xs" align={"center"}>
          <Stack gap="0">
            <Text size="xs" fw={500} mb="xxs" inline>
              Type
            </Text>
            <Badge
              radius="xs"
              color={"gray"}
              // variant="light"
            >
              Status
            </Badge>
          </Stack>
          <Divider orientation="vertical" />
          <Stack gap="0">
            <Text size="xs" fw={500} mb="xxs" inline>
              Status
            </Text>
            <Text size="xs" inline c="dimmed">
              {status}
            </Text>
          </Stack>
          <Divider orientation="vertical" />
          <Stack gap="0">
            <Text size="xs" fw={500} mb="xxs" inline>
              ID
            </Text>
            <Text size="xs" inline c="dimmed">
              {statusId}
            </Text>
          </Stack>
        </Flex>
      </Grid.Col>
    </Grid>
  );
}

export default function Status() {
  // Search params
  let [searchParams] = useSearchParams();
  let entityId = searchParams.get("entityId"),
    id = searchParams.get("id"),
    recon = searchParams.get("recon"),
    runId = searchParams.get("runId"),
    runSeq = searchParams.get("runSeq"),
    access = searchParams.get("access"),
    status = searchParams.get("status"),
    statusId = searchParams.get("statusId");

  // Theme, query client and navigation
  const theme = useMantineTheme();
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  const { data: useCase, isLoading } = useUseCaseBasic(entityId, id);

  const reconDefinition = useCase?.definition.recons.find(
    (r) => r.id === recon
  );

  if (useCase) {
    return (
      <>
        <Stack gap="0">
          <div id="header">
            <Grid
              align="flex-end"
              gutter={"xs"}
              mt="xs"
              mb="xs"
              // mb="xs"
              style={{
                display: "flex",
                // borderLeft: `${theme.spacing.xxs} solid ${theme.colors.emerald[7]}`,
              }}
              columns={12}
            >
              <Grid.Col
                span={2}
                mr="xs"
                style={{ borderRight: `2px solid ${theme.colors.dark[3]}` }}
              >
                <Flex align={"end"} gap={theme.spacing.xs}>
                  <Stack gap={0}>
                    <Title order={3} c="dark">
                      {useCase ? useCase.name : "Use Case"}
                    </Title>
                    {useCase && (
                      <Text size="sm" c="dark">
                        {useCase.displayName}
                      </Text>
                    )}
                  </Stack>
                </Flex>
              </Grid.Col>
              <Grid.Col span={9}>
                <Flex align={"flex-end"} gap="xs">
                  <Details status={status} statusId={statusId} />
                </Flex>
              </Grid.Col>
            </Grid>
          </div>
        </Stack>
        <Divider mt="xs" />

        {reconDefinition && (
          <Stack gap="0" mt="xs">
            {reconDefinition.definition.datasets.map((d) => {
              return (
                <DatasetData
                  key={d.id}
                  entityId={entityId}
                  id={id}
                  recon={reconDefinition.id}
                  runId={runId}
                  runSeq={runSeq}
                  access={access}
                  dataset={d}
                  type="STATUS"
                  status={status}
                  queryId={statusId}
                  fetchOnMount={true}
                />
              );
            })}
          </Stack>
        )}
      </>
    );
  } else {
    return (
      <Grid align="center" gutter={"xs"} mb="xs" mt="lg">
        <Grid.Col span={4}>
          <Loading />
        </Grid.Col>
      </Grid>
    );
  }
}
